export const iconsList = [
    {
      id:1,
      src: 'https://leetcode.com/_next/static/images/list-a671ce9b1030394bb8b1b3d433e1199c.png',
      text: 'My List'
    },
    {
      id:2,
      src: 'https://leetcode.com/_next/static/images/notebook-92e90c87d33d7403f2f016c245b203a7.png',
      text: 'Notebook'
    },
    {
      id:3,
      src: 'https://leetcode.com/_next/static/images/answer-9dab99b273b399a43f8826c193d187d5.png',
      text: 'Submissions'
    },
    {
      id:4,
      src: 'https://leetcode.com/_next/static/images/progress-106c8d8956a5f08d22006a6ea911e6c3.png',
      text: 'Progress'
    },
    {
      id:5,
      src: 'https://leetcode.com/_next/static/images/coin-9ed5754318458315a57c46abd2f431c1.png',
      text: 'Points'
    },
  ]